import React from "react";
import ChatSection from "./chat_section";
import SandeeLogo from "./sandee_logo";
import Footer from "./footer";
import "./pclm.style.css";
import { Layout } from "antd";
import Header from "../../components/Header";

const { Content } = Layout;

export default function PCLM() {
  return (
    <Layout className="pclm-sandee-layout">
      <Header />
      <div className="pclm-background-shapes">
        <div className="pclm-shape pclm-shape-1"></div>
        <div className="pclm-shape pclm-shape-2"></div>
        <div className="pclm-shape pclm-shape-3"></div>
      </div>

      <Content className="pclm-sandee-content">
        <div className="pclm-main-wrapper">
          <SandeeLogo />
          <ChatSection />
        </div>
        <Footer />
      </Content>
    </Layout>
  );
}
